import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import FiscalCapitalBalanceScheduleTable from './FiscalCapitalBalanceScheduleTable';

const FiscalCapitalBalanceSchedule = ({ fiscalCapitalBalanceSchedule }) => {
  return (
    <Box mt={3}>
      <FiscalCapitalBalanceScheduleTable
        fiscalCapitalBalanceSchedule={fiscalCapitalBalanceSchedule}
      />
    </Box>
  );
};

FiscalCapitalBalanceSchedule.propTypes = {
  fiscalCapitalBalanceSchedule: PropTypes.array
};

export default FiscalCapitalBalanceSchedule;


